<script lang="ts">
export default {
  name: "MainFobizzNavbarIconButton",
};
</script>

<script setup lang="ts">
import { type Props as BaseIconProps } from "@/components/Base/Icon/index.vue";
import type { ButtonHTMLAttributes } from "vue";

export type Props = {
  type?: ButtonHTMLAttributes["type"];
  iconName: BaseIconProps["iconName"];
  label: string;
};

withDefaults(defineProps<Props>(), {
  type: "button",
});
</script>

<template>
  <button
    class="main-fobizz-navbar__link main-fobizz-navbar__nav-icon"
    :type="type"
    :aria-label="label"
  >
    <BaseIcon :icon-name="iconName" color="inherit" size="inherit" />
  </button>
</template>
